import './set_plan_chart_height_from'

up.compiler('.js-publication_revenue_chart', function (element) {
  import(/* webpackChunkName: "publication_analytics_revenue_chart" */ './analytics/revenue.tsx').then(
    ({ default: initChart }) => {
      const destructor = initChart(element)
      up.destructor(element, () => destructor())
    }
  )
})

up.compiler('.js-publication_members_chart', function (element) {
  import(/* webpackChunkName: "publication_analytics_members_chart" */ './analytics/members.tsx').then(
    ({ default: initChart }) => {
      const destructor = initChart(element)
      up.destructor(element, () => destructor())
    }
  )
})

up.compiler('.js-publication_trial_members_chart', function (element) {
  import(/* webpackChunkName: "publication_analytics_trial_members_chart" */ './analytics/trial_members.tsx').then(
    ({ default: initChart }) => {
      const destructor = initChart(element)
      up.destructor(element, () => destructor())
    }
  )
})

up.compiler('.js-publication_churn_rate_chart', function (element) {
  import(/* webpackChunkName: "publication_analytics_churn_rate_chart" */ './analytics/churn_rate.tsx').then(
    ({ default: initChart }) => {
      const destructor = initChart(element)
      up.destructor(element, () => destructor())
    }
  )
})

up.compiler('.js-publication_subscribers_chart', function (element) {
  import(/* webpackChunkName: "publication_analytics_free_members_chart" */ './analytics/free_members.tsx').then(
    ({ default: initChart }) => {
      const destructor = initChart(element)
      up.destructor(element, () => destructor())
    }
  )
})

up.compiler('.js-publication_analytics__plans', function (element) {
  import(/* webpackChunkName: "publication_analytics_plans_charts" */ './analytics/plans_chart.js').then(
    ({ default: initChart }) => {
      const hideAllCharts = () =>
        element.querySelectorAll('.js-publication_plans_chart').forEach(chart => {
          chart.style.display = 'none'
        })

      const showSelectedChart = () => {
        const chartTypeInput = element.querySelector('input[name="plan_chart_type"]:checked')
        if (chartTypeInput) {
          const selected = chartTypeInput.value
          element.querySelector(`.js-publication_plans_chart[data-type="${selected}"]`).style.display = 'block'
          return initChart(element, selected)
        }
      }

      hideAllCharts()
      let chart = showSelectedChart()

      const updateSelectedChart = () => {
        chart.destroy()
        hideAllCharts()
        chart = showSelectedChart()
      }

      const openTooltip = () => {
        chart.tooltip.setActiveElements([
          { datasetIndex: 0, index: 0 },
          { datasetIndex: 0, index: 1 }
        ])
        chart.render()
      }

      const closeTooltip = () => {
        chart.tooltip.setActiveElements([])
        chart.render()
      }

      const typeSwitchRadios = element.querySelectorAll('input[name="plan_chart_type"]')
      const chartContainer = element.querySelectorAll('.js-publication_plans_chart')

      typeSwitchRadios.forEach(input => input.addEventListener('change', updateSelectedChart))
      chartContainer.forEach(container => {
        container.addEventListener('focus', openTooltip)
        container.addEventListener('blur', closeTooltip)
      })

      up.destructor(element, () => {
        chart.destroy()
        typeSwitchRadios.forEach(input => input.removeEventListener('change', updateSelectedChart))

        chartContainer.forEach(container => {
          container.removeEventListener('focus', openTooltip)
          container.removeEventListener('blur', closeTooltip)
        })
      })
    }
  )
})
